const Logo = ({ ...props }) => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            width="110"
            height="40"
            x="0px"
            y="0px"
            viewBox="0 0 559.93 135.13"
            xmlSpace="preserve"
        >
            <path
                d="M384.57,126.47l-33.84-35.23h-14.42v32.28c0,2.35-1.91,4.26-4.26,4.26h-18.43c-2.35,0-4.26-1.91-4.26-4.26V8.28
       c0-2.35,1.91-4.26,4.26-4.26h18.43c2.35,0,4.26,1.91,4.26,4.26V64.7h7.93l35.63-58.64c0.77-1.27,2.15-2.04,3.63-2.04h22.47
       c3.34,0,5.38,3.67,3.61,6.51l-39.73,63.55l44.89,46.48c2.61,2.71,0.7,7.22-3.07,7.22h-24.03
       C386.48,127.78,385.37,127.31,384.57,126.47z M517.27,5.92l42.4,116.13c1.02,2.78-1.04,5.72-4,5.72H535.9c-1.8,0-3.4-1.12-4.01-2.81
       l-7.64-21.13h-57.36l-7.6,21.12c-0.61,1.69-2.21,2.82-4.01,2.82h-19.17c-2.96,0-5.02-2.94-4-5.72l42.4-116.13
       c0.61-1.68,2.21-2.8,4-2.8h34.76C515.06,3.12,516.66,4.24,517.27,5.92z M515.3,79.09l-18.35-50.75h-2.88L475.8,79.09H515.3z
        M217.7,1.88c-36.82,0-65.69,28.45-65.69,64.01s28.87,64.01,65.69,64.01s65.69-28.45,65.69-64.01S254.52,1.88,217.7,1.88z
        M217.7,104.81c-20.92,0-38.07-17.99-38.07-38.91s17.15-38.91,38.07-38.91s38.07,17.99,38.07,38.91S238.62,104.81,217.7,104.81z
        M65.69,1.88C28.87,1.88,0,30.33,0,65.89s28.87,64.01,65.69,64.01s65.69-28.45,65.69-64.01S102.51,1.88,65.69,1.88z M65.69,104.81
       c-20.92,0-38.07-17.99-38.07-38.91s17.15-38.91,38.07-38.91s38.07,17.99,38.07,38.91S86.61,104.81,65.69,104.81z"
            />
        </svg>
    )
}

export default Logo
